import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'

export const STORE_REGION_FRAGMENT = gql`
  fragment StoreRegion on Region {
    id
    name
    parentId
    users {
      ...User
    }
    stores {
      id
      name
    }
  }
  ${USER_FRAGMENT}
`
